import { TextControl, PanelBody } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import IconDisplay from "../../../../components/IconDisplay";

export default function DefaultStateSettings({ attributes, setAttributes }) {
  const { defaultText, defaultIcon, useIcon = true } = attributes;

  return (
    <>
      <PanelBody
        title={__("Default State Settings", "brandy-blocks")}
        initialOpen={true}
      >
        <div>
          <TextControl
            __nextHasNoMarginBottom
            label={__("Default Text", "brandy-blocks")}
            help={__("Leave it empty to hide", "brandy-blocks")}
            value={defaultText ?? ""}
            onChange={(value) => setAttributes({ defaultText: value })}
          />
        </div>
        {useIcon && (
          <div style={{ marginTop: "10px" }}>
            <IconDisplay
              name={defaultIcon.name}
              type={defaultIcon.type}
              handleChangeAttributes={(updates) =>
                setAttributes({ defaultIcon: { ...defaultIcon, ...updates } })
              }
            />
          </div>
        )}
      </PanelBody>
    </>
  );
}
